export const RATIO = 3 / 2; // DAT backend returns images in 3:2 ratio
